import { NPIDataGridColDef } from 'src/components/NPIDataGrid/NPIDataGrid';
import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';
import StatusChip, { STATUS_CHIP_TYPES } from 'src/components/UserStatusChip/UserStatusChip';
import { SepaAgreementCallToActions } from 'src/features/finance/sepaDirectDebits/components/SepaAgreementTables/SepaAgreementTable/SepaAgreementCallToActions/SepaAgreementCallToActions';
import { SEPA_MANDATE_AGREEMENT_TABLE_TYPE } from 'src/utils/tableUtils';

import { SepaAgreementColumnsProps } from './SepaAgreementTables.types';

function createSepaAgreementColumns({
    handleViewRecord,
    setIdToDelete,
    setIsDeleteConfirmModalOpen,
    setIsRemindConfirmModalOpen,
    setIdToRemind,
    entityType,
    agreementType,
}: SepaAgreementColumnsProps & {
    entityType: 'Merchant' | 'Partner';
    agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE;
}): NPIDataGridColDef[] {
    return [
        createColumnDef({
            field: 'accountNumber',
            headerName: 'Account Number',
        }),
        createColumnDef({
            field: 'tradingName',
            headerName: entityType,
        }),
        createColumnDef({
            field: 'addedByName',
            headerName: 'Added By',
        }),
        createColumnDef({
            field: 'sentToEmail',
            headerName: 'Sent To',
            minWidth: 250,
        }),
        createColumnDef({
            field: 'contactName',
            headerName: 'Contact Name',
            minWidth: 150,
        }),
        createColumnDef({
            field: 'status',
            headerName: 'Status',
            minWidth: 300,
            renderCell: (params) => {
                return (
                    <StatusChip
                        status={params?.row?.status}
                        type={STATUS_CHIP_TYPES.SEPA_DD_MANDATE}
                    />
                );
            },
        }),
        createColumnDef({
            field: 'actions',
            minWidth: 100,
            renderCell: (params) => {
                return (
                    <SepaAgreementCallToActions
                        dataTestIdKey={entityType.toLowerCase()}
                        setIsDeleteConfirmModalOpen={setIsDeleteConfirmModalOpen}
                        setIdToDelete={setIdToDelete}
                        handleViewRecord={handleViewRecord}
                        params={params}
                        setIdToRemind={setIdToRemind}
                        setIsRemindConfirmModalOpen={setIsRemindConfirmModalOpen}
                        agreementType={agreementType}
                    />
                );
            },
        }),
    ];
}

export function getMerchantSepaAgreementColumns(
    props: SepaAgreementColumnsProps
): NPIDataGridColDef[] {
    return createSepaAgreementColumns({
        ...props,
        entityType: 'Merchant',
        agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE.MERCHANT,
    });
}

export function getPartnerSepaAgreementColumns(
    props: SepaAgreementColumnsProps
): NPIDataGridColDef[] {
    return createSepaAgreementColumns({
        ...props,
        entityType: 'Partner',
        agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE.PARTNER,
    });
}
